import React, { ErrorInfo } from 'react'
import logger from 'shared/services/logger'
import Button from 'shared/timber/v1/Button'
import EmptyState from 'shared/timber/v1/EmptyState'
import Icon from 'shared/timber/v1/Icon'

import styles from './styles.module.scss'

interface Props {
  children: React.ReactNode
  onClose(): void
}

interface State {
  hasError: boolean
  message?: string
}

export default class FormDrawerErrorBoundary extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error) {
    return {
      hasError: true,
      message: error.message,
    }
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    logger.error(error, {
      key: 'legacy-form-drawer',
      extra: {
        componentStack: info.componentStack || '',
      },
    })
  }

  override render() {
    if (this.state.hasError) {
      return (
        <div className={styles.ErrorBoundary}>
          <EmptyState size="lg">
            <EmptyState.Icon>
              <Icon icon="alert_triangle" background="error" />
            </EmptyState.Icon>

            <EmptyState.Title>Oops</EmptyState.Title>
            <EmptyState.Description>
              Something went wrong loading this detail. Please try again.
              {this.state.message && (
                <pre className={styles.ErrorBlock}>
                  <code>{this.state.message}</code>
                </pre>
              )}
            </EmptyState.Description>
            <EmptyState.Footer>
              <Button fullWidth onClick={this.props.onClose}>
                Close
              </Button>
            </EmptyState.Footer>
          </EmptyState>
        </div>
      )
    }

    return this.props.children
  }
}
